import { useLocation } from 'react-router-dom';
import { AppLink } from '/src/features/_global/components/AppLink';

export function LinkWithParams({ to, disabled = false, className = null, excluded = [], children }) {
  const location = useLocation();

  const search = new URLSearchParams(location.search);
  for (const key of excluded) {
    search.delete(key);
  }

  if (disabled) {
    return <span className={className}>{children}</span>;
  }
  return (
    <AppLink
      className={className}
      to={{
        pathname: to,
        search: search.toString(),
      }}
    >
      {children}
    </AppLink>
  );
}
